import { render, staticRenderFns } from "./Pricing.html?vue&type=template&id=61a0277c&scoped=true&external"
import script from "./Pricing.js?vue&type=script&lang=js&external"
export * from "./Pricing.js?vue&type=script&lang=js&external"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=61a0277c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a0277c",
  null
  
)

export default component.exports